"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowNodeParsers = void 0;
/* eslint-disable @typescript-eslint/no-unused-vars */
const activityParser = require("./ActivityParser");
const eventParser = require("./EventParser");
const gatewayParser = require("./GatewayParser");
var FlowNodeParsers;
(function (FlowNodeParsers) {
    FlowNodeParsers.ActivityParser = activityParser;
    FlowNodeParsers.EventParser = eventParser;
    FlowNodeParsers.GatewayParser = gatewayParser;
})(FlowNodeParsers = exports.FlowNodeParsers || (exports.FlowNodeParsers = {}));
//# sourceMappingURL=index.js.map